export interface IWorldState {
    worldNumber: number;
}

export const initialWorldState: IWorldState = {
    worldNumber: 1,
};
